import Vue from 'vue';
import axios from "axios";
import router from "@/router";

export const actions = {
  async handle_pacient ({ rootState, dispatch }, pacient) {
    try {
      Vue.set(rootState, 'isLoading', true);
      pacient.birthdate = pacient.date;
      delete pacient.date;
      pacient.telefon = pacient.telefon.replace(/ /g, '');
      dispatch(pacient.id ? 'update_pacient' : 'save_new_pacient', pacient);
    }
    catch (err) {
      console.log(`eroare handle pacient`);
    }
  },
  async save_new_pacient ({ rootState }, pacient) {
    try {
      pacient.createdAt = Date.now();
      const { data } = await axios.post('/api/save-pacient', pacient);
      console.log(data);
      const pacienti = [data, ...rootState.pacientiModule.pacienti];
      Vue.set(rootState.pacientiModule, 'pacienti', pacienti);
      Vue.set(rootState, 'isLoading', false);
      await router.push('/pacienti');
    }
    catch (err) {
      window.alert('Eroare salvare pacient.');
    }
  },
  async update_pacient({ rootState }, pacient) {
    try {
      const skipRedirect = pacient.skipRedirect;

      const pacientData = { ...pacient };
      delete pacientData.skipRedirect;

      const { data } = await axios.post(
        `/api/update-pacient/${router.currentRoute.params.id}`,
        pacientData
      );

      const pacientiFiltered =
        rootState.pacientiModule.pacienti
          .filter((obj) => +obj.id !== +data.id);

      Vue.set(rootState.pacientiModule, 'pacienti', [data, ...pacientiFiltered]);

      rootState.isLoading = false;

      if (pacient.onlyFeedbackUpdate && !skipRedirect) {
        await router.push('/pacienti');
      }

    } catch (err) {
      console.log('Eroare update date pacient.', err);
      rootState.isLoading = false;
    }
  }
}

export const mutations = {}

